import moment from "moment";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { usDateFormat } from "../../utils";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";

const FeeHomeCard = ({
  description,
  data,
  dataWidth,
  getStatus,
  isFeeTransaction = false,
  isFeeDetails = false,
}) => {
  const feeDetails = {
    name: data.name,
    feeClassification: data.feeClassification,
    noOfPlans: data.numberOfPlans,
    feeType: data.feeType,
    feeRunType: data.feeRunType,
    nextRunDate: data.nextRunDate,
    feeStatus: data.feeStatus,
  };
  const feeTransaction = {
    name: data.name,
    classification: data.classification,
    noOfPlans: data.noOfPlans,
    feeCollected: data.feeCollected,
    feeRunDate: data.feeRunDate,
    feeRunStatus: data.feeRunStatus,
  };
  const filteredData = isFeeDetails
    ? feeDetails
    : isFeeTransaction
    ? feeTransaction
    : null;
  const objArray = [];
  Object.values(filteredData).forEach((key) =>
    objArray.push({
      name: key,
    })
  );
  let dataAndWidth = objArray.map((item, i) =>
    Object.assign({}, item, dataWidth[i])
  );
  return (
    <>
      <div
        className="d-flex justify-content-space-between p-2"
        style={{ height: "3.25rem" }}
      >
        {dataAndWidth.map((item, index) => {
          if (index == 0) {
            return (
              <div
                style={{
                  width: item.width,
                  textAlign: item.align,
                  color: "#242426",
                }}
                className="d-flex flex-col justify-content-center"
              >
                {item.name?.length > 20 ? (
                  <OverlayTrigger
                    placement="top-start"
                    overlay={<Tooltip>{item.name}</Tooltip>}
                  >
                    <div className="fw-600 ft-16">
                      {(item.name || "").slice(0, 20)}
                      {item.name?.length > 20 ? "..." : null}
                    </div>
                  </OverlayTrigger>
                ) : (
                  <div className="fw-600 ft-16">{item?.name}</div>
                )}
                {description?.length > 25 ? (
                  <OverlayTrigger
                    placement="top-start"
                    overlay={<Tooltip>{description}</Tooltip>}
                  >
                    <div className="grey-text">
                      {(description || "").slice(0, 25)}
                      {description?.length > 25 ? "..." : null}
                    </div>
                  </OverlayTrigger>
                ) : description == "" ? (
                  ""
                ) : (
                  <div className="grey-text">{description}</div>
                )}
              </div>
            );
          } else if (index == dataAndWidth.length - 1) {
            return (
              <div
                className="d-flex flex-col justify-content-center ft-14"
                style={{ width: item.width, textAlign: item.align }}
              >
                {getStatus(item.name)}
              </div>
            );
          } else if (
            typeof item.name === "string" &&
            item.name?.includes("-") &&
            item.name?.includes(":") &&
            item.name?.includes("T") &&
            item.name?.includes("Z")
          ) {
            return (
              <div
                className="d-flex flex-col justify-content-center ft-14"
                style={{ width: item.width, textAlign: item.align }}
              >
                <div>{usDateFormat(item.name) ?? "-"}</div>
                <div className="grey-text">
                  {new moment(item.name).format("HH:mm") ?? ""}
                </div>
              </div>
            );
          } else {
            return item.name?.length > 15 ? (
              <OverlayTrigger
                placement="top-start"
                overlay={<Tooltip>{item.name}</Tooltip>}
              >
                <div
                  className="d-flex flex-col justify-content-center ft-14"
                  style={{ width: item.width, textAlign: item.align }}
                >
                  {(item.name || "").slice(0, 15)}
                  {item.name?.length > 5 ? "..." : null}
                </div>
              </OverlayTrigger>
            ) : (
              <div
                className="d-flex flex-col justify-content-center ft-14"
                style={{ width: item.width, textAlign: item.align }}
              >
                {item.name == ""
                  ? "-"
                  : isNullOrUndefined(item.name)
                  ? "-"
                  : item.name}
              </div>
            );
          }
        })}
        {/* <div style={{ width: "30%" }} className="d-flex flex-col">
            <div>
              {data.name?.length > 25 ? (
                <OverlayTrigger
                  placement="top-start"
                  overlay={<Tooltip>{data.name}</Tooltip>}
                >
                  <p>
                    {(data.name || "").slice(0, 25)}
                    {data.name?.length > 25 ? "..." : null}
                  </p>
                </OverlayTrigger>
              ) : (
                data.name
              )}
            </div>
            <div className="grey-text">
              {description?.length > 25 ? (
                <OverlayTrigger
                  placement="top-start"
                  overlay={<Tooltip>{description}</Tooltip>}
                >
                  <p>
                    {(description || "").slice(0, 25)}
                    {description?.length > 25 ? "..." : null}
                  </p>
                </OverlayTrigger>
              ) : description == "" ? (
                ""
              ) : (
                description
              )}
            </div>
          </div>
          <div style={{ width: "20%", textAlign: "center" }}>
            {data.feeClassification?.length > 15 ? (
              <OverlayTrigger
                placement="top-start"
                overlay={<Tooltip>{data.feeClassification}</Tooltip>}
              >
                <p>
                  {(data.feeClassification || "").slice(0, 15)}
                  {data.feeClassification?.length > 15 ? "..." : null}
                </p>
              </OverlayTrigger>
            ) : (
              data.feeClassification ?? "-"
            )}
          </div>
          <div style={{ width: "15%", textAlign: "center" }}>
            {data.feeType ?? "-"}
          </div>
          <div style={{ width: "20%", textAlign: "center" }}>
            {data.scheduleType ?? "-"}
          </div>
          <div style={{ width: "20%", textAlign: "center" }}>
            <div>{usDateFormat(data.nextRunDate) ?? "-"}</div>
            <div>{new moment(data.nextRunDate).format("HH:mm") ?? ""}</div>
          </div>
          <div style={{ width: "15%", textAlign: "center" }}>
            {getStatus(data.feeStatus)}
          </div> */}
      </div>
    </>
  );
};

export default FeeHomeCard;
